/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback, useEffect, useState} from "react";
import { GridView, Griew, Column, Response } from "react-griew";
import Pasoonate from "pasoonate";
import i18n from "../../../plugins/locale/i18n";
import loadDictionary from "../../../plugins/locale/load-dictionary";
import ZeroOutBonCardWindow from "./ZeroOutBonCardWindow.jsx";
import ChargeBonCardWindow from "./ChargeBonCardWindow.jsx";
import BankAccountService from "../../../service/bank-account-service.js";

const bankAccountService = new BankAccountService();
const griew = new Griew();

await loadDictionary('bank-account-bon-card-list-page')

function BonCardListPage() {
    const [count, setCount] = useState(0);
    const [isOpenZeroOutBonCardWindow, setIsOpenZeroOutBonCardWindow] = useState(false);
    const [zeroOutButtonState, setZeroOutButtonState] = useState('disabled');
    const [isOpenChargeBonCardWindow, setIsOpenChargeBonCardWindow] = useState(false);
    const [chargeButtonState, setChargeButtonState] = useState('disabled');
    const [selectedBonCards, setSelectedBonCards] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const prepareGriew = useCallback((setCount, selectBonCard, selectedBonCards, setIsLoading) => {
      const list = [
        {
          name: "check",
          caption: " ",
          schema: "BankAccount",
          type: Column.NUMBER,
          order: 1,
          sortable: false,
          filterable: false,
          visibility: true,
          beforeRender: (value, bankAccount) => {
            const hasAccount = selectedBonCards.find(item => item.id === bankAccount.id) !== undefined;
            
            return <input type="checkbox" className="form-check-input" checked={hasAccount} disabled={bankAccount.balance === null} onChange={(e) => selectBonCard(e.target, bankAccount)}/>;
          }
        },
        {
          name: "id",
          caption: "کد",
          schema: "BankAccount",
          type: Column.NUMBER,
          order: 1,
          sortable: false,
          filterable: false,
          visibility: true,
        },
        {
          name: "type",
          caption: "نوع",
          schema: "BankAccount",
          type: Column.STRING,
          order: 1,
          sortable: false,
          filterable: false,
          visibility: false,
        },
        {
          name: "name",
          caption: "نام حساب",
          schema: "BankAccount",
          type: Column.STRING,
          order: 2,
          sortable: false,
          filterable: false,
          visibility: true,
        },
        {
          name: "bank_name",
          caption: "نام بانک",
          schema: "Bank",
          type: Column.STRING,
          order: 3,
          sortable: false,
          filterable: false,
          visibility: true,
          beforeRender: (value, bankAccount) => {
            return bankAccount?.bank?.name;
          }
        },
        {
          name: "account_number",
          caption: "شماره حساب",
          schema: "BankAccount",
          type: Column.STRING,
          order: 4,
          sortable: false,
          filterable: false,
          visibility: true,
        },
        {
          name: "card_number",
          caption: "شماره کارت",
          schema: "BankAccount",
          type: Column.STRING,
          order: 5,
          sortable: false,
          filterable: false,
          visibility: true,
        },
        {
          name: "balance",
          caption: "موجودی",
          schema: "BankAccount",
          type: Column.STRING,
          order: 6,
          sortable: false,
          filterable: false,
          visibility: true,
          beforeRender: (value) => { 
            return <span dir="ltr">{value === null ? '' : Number(value).toLocaleString('en-US')}</span>;
          },
        },
        {
          name: "created_at",
          caption: "تاریخ ایجاد",
          schema: "BankAccount",
          type: Column.DATETIME,
          order: 7,
          sortable: false,
          filterable: false,
          visibility: true,
          beforeRender: (value) => { 
            const createdAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yy/MM/dd HH:mm");
      
            return <span dir="ltr">{createdAt}</span>;
          },
        },
        {
          name: "updated_at",
          caption: "تاریخ ویرایش",
          schema: "Party",
          type: Column.DATETIME,
          order: 8,
          sortable: false,
          filterable: false,
          visibility: true,
          beforeRender: (value) => { 
            const updatedAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yy/MM/dd HH:mm");
      
            return <span dir="ltr">{updatedAt}</span>;
          },
        }
      ];

      const callback = function (promis) {
        promis.then(response => {
          const pagination = response.pagination;
          const data = response.data;

          const res = Response.make({
            data: data,
            pagination: {
              currentPage: pagination?.currentPage ?? 1,
              lastPage: pagination?.lastPage ?? 1,
              perPage: pagination?.perPage ?? 15,
              total: pagination?.total ?? 1,
              from: pagination?.from ?? 1,
              to: pagination?.to ?? 1,
            }
          });

          griew.refresh(res);

          setCount(pagination.total);

          setIsLoading(false);
        })
        .catch(error => {
          console.log(error);
        });
      };

      griew.localization.locale = 'fa';
      griew.columns.fromArray(list);
      griew.providers.default = 'function';
      griew.providers.getProvider().options = {
        function: (query) => {
          setIsLoading(true);

          return bankAccountService.gridview(query);
        },
        callback: callback
      };

    }, [selectedBonCards]);

    const reloadList = () => {  
      setSelectedBonCards([]);
        
      griew.filters.add('type', 'String', 'IsEqualTo', 'bon_card', null);
      griew.options.add('balance', true);
      griew.options.add('accessible_accounts', true);

      griew.refresh(); 
    };

    const selectBonCard = (element, account) => {
        if(element.checked) {
            setSelectedBonCards(prev => [...prev, account]);
            
        } else {
            setSelectedBonCards(prev => prev.filter(item => item.id !== account.id));
        }
    };

    const handleOpenZeroOutBonCardWindow = () => {
      setIsOpenZeroOutBonCardWindow(true);
    };

    const handleCloseZeroOutBonCardWindow = (event, refresh = false) => {
      setIsOpenZeroOutBonCardWindow(false);

      if(refresh) {
        reloadList();
      }
    };

    const handleOpenChargeBonCardWindow = () => {
      setIsOpenChargeBonCardWindow(true);
    };

    const handleCloseChargeBonCardWindow = (event, refresh = false) => {
      setIsOpenChargeBonCardWindow(false);

      if(refresh) {
        reloadList();
      }
    };

    useEffect(() => {
        prepareGriew(setCount, selectBonCard, selectedBonCards, setIsLoading);
        reloadList();
    }, []);

    useEffect(() => {
        setZeroOutButtonState(selectedBonCards.length ? '' : 'disabled');
        setChargeButtonState(selectedBonCards.length ? '' : 'disabled');
    }, [selectedBonCards]);

    useEffect(() => {
      prepareGriew(setCount, selectBonCard, selectedBonCards, setIsLoading);
      griew.render();
    }, [prepareGriew]);

    return (
        <div className="page">
            <div className="page-header bg-body p-3">
                <h4 className="page-title">{i18n.t("bank-account-bon-card-list-page.page_title")}</h4>
                <div className="header-content"></div>
            </div>
            <div className="content-area bg-body-tertiary p-3">
                <div className="row mb-2">
                    <div className="table-title col">
                        <h5 className="mt-1 mb-3">{i18n.t("bank-account-bon-card-list-page.table_title")} ({count})</h5>
                    </div>
                    <div className="table-toolbar col-auto">
                      <button className={"btn btn-sm btn-secondary me-2 mb-2 " + chargeButtonState} type="button" onClick={() => {setSelectedBonCards([])}}>{i18n.t("bank-account-bon-card-list-page.clear_selections_button")}</button>
                      <button className={"btn btn-sm btn-primary me-2 mb-2 " + chargeButtonState} type="button" onClick={handleOpenChargeBonCardWindow}>{i18n.t("bank-account-bon-card-list-page.charge_button")}</button>
                      <button className={"btn btn-sm btn-primary me-2 mb-2 " + zeroOutButtonState} type="button" onClick={handleOpenZeroOutBonCardWindow}>{i18n.t("bank-account-bon-card-list-page.zero_out_button")}</button>
                      <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'rotate' : '')} type="button" onClick={reloadList}><i className="bi bi-arrow-clockwise"></i></button>
                    </div>
                </div>
                <div className="table-responsive">
                    <GridView griew={griew} ></GridView>
                </div>
            </div>
            <ZeroOutBonCardWindow isOpenWindow={isOpenZeroOutBonCardWindow} onCloseWindow={handleCloseZeroOutBonCardWindow} bonCards={selectedBonCards} />
            <ChargeBonCardWindow isOpenWindow={isOpenChargeBonCardWindow} onCloseWindow={handleCloseChargeBonCardWindow} bonCards={selectedBonCards} />
        </div>
    ); 
}

export default BonCardListPage;